<template>
    <div class="token-bar fixed-bottom bg-black bg-opacity-50" :class="{ active: open }">
        <div class="container px-3 px-xl-6">
            <div class="d-flex flex-column flex-lg-row align-items-lg-center py-4">
                <div class="d-flex align-items-center">
                    <img src="/svg/xrp-icon.svg" alt="XRP Icon" class="me-3">
                    <div class="fw-bolder">
                        <span class="mb-2 fs-24 fw-bold">XRP</span>
                        <div class="d-flex align-items-center">
<!--                            <svg v-if="!loadingTokenBalance" height="16" width="16" class="me-1 text-success">-->
<!--                                <use xlink:href="#caret-up-circle"></use>-->
<!--                            </svg>-->
                            <span class="me-1 fs-16 fw-bold">XRP:</span>
                            <spinner-component v-if="loadingTokenBalance" color="text-light"/>
                            <span v-else class="fs-14 fw-medium">
                                {{ roundOff(tokens.xrpBalance.balance) }}
<!--                                <span class="ms-2 text-success">(+0.20%)</span>-->
                            </span>
                        </div>
                    </div>
                </div>
                <div class="hada-balance mx-lg-6 my-4 my-lg-0 px-lg-6 d-flex align-items-center border-grey-200">
                    <img src="/svg/hada-icon.svg" alt="Hada Icon" class="me-3">
                    <div class="fw-bolder">
                        <span class="mb-2 fs-24 fw-bold">HADA</span>
                        <div class="d-flex align-items-center">
<!--                            <svg v-if="!loadingTokenBalance" height="16" width="16" class="me-1 text-success">-->
<!--                                <use xlink:href="#caret-up-circle"></use>-->
<!--                            </svg>-->
                            <span class="me-1 fs-16 fw-bold">HAD:</span>
                            <spinner-component v-if="loadingTokenBalance" color="text-light"/>
                            <span v-else class="fs-14 fw-medium">
                                {{ roundOff(tokens.hada.balance) }}
<!--                                <span class="ms-2 text-success">(+0.20%)</span>-->
                            </span>
                        </div>
                    </div>
                </div>
                <div class="d-flex align-items-center">
                    <img src="/svg/hadalite-icon.svg" alt="Hadalite Icon" class="me-3">
                    <div class="fw-bolder">
                        <span class="mb-2 fs-24 fw-bold">HADALITE</span>
                        <div class="d-flex align-items-center">
<!--                            <svg v-if="!loadingTokenBalance" height="16" width="16" class="me-1 text-secondary">-->
<!--                                <use xlink:href="#caret-down-circle"></use>-->
<!--                            </svg>-->
                            <span class="me-1 fs-16 fw-bold">HDL:</span>
                            <spinner-component v-if="loadingTokenBalance" color="text-light"/>
                            <span v-else class="fs-14 fw-medium">
                                {{ roundOff(tokens.hadalite.balance) }}
<!--                                <span class="ms-2 text-secondary">(+0.20%)</span>-->
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <button class="token-bar--toggle border-0 p-2 fs-14 fw-bold position-absolute end-0 bg-black bg-opacity-50"
                :class="{'active text-success': open, 'text-grey-200': !open}"
                @click="open = !open">
            <svg width="24" height="24" class="me-1">
                <use xlink:href="#caret-up-circle-outline"></use>
            </svg>
            {{ open ? 'Hide Balance' : 'Show Balance' }}
        </button>
    </div>
</template>

<script>
import SpinnerComponent from '@/Components/Common/SpinnerComponent'

export default {
	name: 'TokenBannerComponent',

	props: {
		tokens: Object
	},

	data() {
		return {
			open: false
		}
	},

	components: {
		SpinnerComponent
	},

	computed: {
		loadingTokenBalance() {
			return Object.keys(this.tokens).length === 0
		}
	}
}
</script>

<style lang="scss" scoped>
.token-bar--toggle {
    svg {
        transition: all 0.3s ease-in-out;
    }

    &.active {
        svg {
            rotate: 180deg;
        }
    }
}

@media screen and (min-width: 1024px) {
    .token-bar--toggle {
        svg {
            rotate: 180deg;
        }

        &.active {
            svg {
                rotate: 0deg;
            }
        }
    }
}
</style>
